import { AppConfigDto, UpdateAppConfigsRequest } from "../../interfaces";

//#region Get App Configs

export const GET_APP_CONFIGS = "GET_APP_CONFIGS";
export const GET_APP_CONFIGS_SUCCESS: any = "GET_APP_CONFIGS_SUCCESS";
export const GET_APP_CONFIGS_ERROR: any = "GET_APP_CONFIGS_ERROR";

export interface GetAppConfigsAction {
  type: typeof GET_APP_CONFIGS;
  payload: {};
}

export interface GetAppConfigsSuccessAction {
  type: typeof GET_APP_CONFIGS_SUCCESS;
  payload: AppConfigDto[];
}

export interface GetAppConfigsErrorAction {
  type: typeof GET_APP_CONFIGS_ERROR;
  payload: any;
}
//#endregion

//#region Update App Configs

export const UPDATE_APP_CONFIGS = "UPDATE_APP_CONFIGS";
export const UPDATE_APP_CONFIGS_SUCCESS: any = "UPDATE_APP_CONFIGS_SUCCESS";
export const UPDATE_APP_CONFIGS_ERROR: any = "UPDATE_APP_CONFIGS_ERROR";

export interface UpdateAppConfigsAction {
  type: typeof UPDATE_APP_CONFIGS;
  payload: { request: UpdateAppConfigsRequest };
}

export interface UpdateAppConfigsSuccessAction {
  type: typeof UPDATE_APP_CONFIGS_SUCCESS;
  payload: AppConfigDto[];
}

export interface UpdateAppConfigsErrorAction {
  type: typeof UPDATE_APP_CONFIGS_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetAppConfigsAction
  | GetAppConfigsSuccessAction
  | GetAppConfigsErrorAction
  | UpdateAppConfigsAction
  | UpdateAppConfigsSuccessAction
  | UpdateAppConfigsErrorAction;
